import React, { useState, useEffect, useCallback } from "react";
import { api } from "../features/apiServices/apiClient";
import { useNavigate } from "react-router-dom";
import "./css/DeliveryPage.css";
import ModalMesaClick from "../components/ModalMesaClick";
import safeJSON from "../components/safeJSON";
import { gerarPayloadPix } from "../utils/pixUtils";


const DeliveryPage = () => {
    const navigate = useNavigate();

    const token = localStorage.getItem("accessToken");
    const tenant = safeJSON("tenant");
    const user = safeJSON("user");
    const activeRestaurant = safeJSON("activeRestaurant");

    const [mesaDelivery, setMesaDelivery] = useState(null);
    const [comandaDelivery, setComandaDelivery] = useState(null);

    const [itensMenu, setItensMenu] = useState([]);
    const [categoriasMenu, setCategoriasMenu] = useState([]);
    const [categoriaSel, setCategoriaSel] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);

    const [comandaSelecionada, setComandaSelecionada] = useState(null);
    const [mesaSelecionada, setMesaSelecionada] = useState(null);
    const [showMenuPanel, setShowMenuPanel] = useState(false);
    const [showModalComanda, setShowModalComanda] = useState(false);
    const [showEnderecoModal, setShowEnderecoModal] = useState(false);
    const [clienteNome, setClienteNome] = useState("");
    const [clienteTelefone, setClienteTelefone] = useState("");
    const [clienteEndereco, setClienteEndereco] = useState("");
    const [clienteObs, setClienteObs] = useState("");

    const [qtd, setQtd] = useState(1);
    const [obs, setObs] = useState("");

    const [modalMessage, setModalMessage] = useState("");
    const [modalOpen, setModalOpen] = useState(false);
    const [mesas, setMesas] = useState([]);
    const [kpis, setKpis] = useState({ total: 0, pendentes: 0 });
    const [printerConfig, setPrinterConfig] = useState(null);

    const Headers = {
        Authorization: `Bearer ${token}`,
        "x-tenant-slug": tenant.slug,
    };

    // ======================================================
    // BUSCAR MESAS DELIVERY
    // ======================================================
    const loadMesas = useCallback(async () => {
        try {
            const mesasResponse = await api.get(`/tables?restaurant_id=${activeRestaurant.id}`, { headers: Headers });
            let listMesasData = mesasResponse.data || [];

            let mesasData = listMesasData.filter(mesa =>
                typeof mesa.name === "string" &&
                mesa.name.toLowerCase().startsWith("delivery") &&
                mesa.status !== "encerrado"
            );

            const comandasResponse = await api.get(`/comandas/restaurant/${activeRestaurant.id}`, { headers: Headers });
            let listCcomandasData = comandasResponse.data || [];

            let comandasData = listCcomandasData.filter(c =>
                typeof c.mesa === "string" &&
                c.mesa.toLowerCase().startsWith("delivery") &&
                c.status === "aberta"
            );

            for (const comanda of comandasData) {
                const pedidosResponse = await api.get(`/pedido/comanda/${comanda.comanda_id}`, { headers: Headers });
                comanda.pedidos = pedidosResponse.data || [];
            }

            const mesasComComandas = mesasData.map((mesa) => {
                const comandaDaMesa = comandasData.find((c) => c.mesa === mesa.name);
                return {
                    ...mesa,
                    comanda_aberta: comandaDaMesa ? { ...comandaDaMesa, pedidos: comandaDaMesa.pedidos || [] } : null,
                };
            });

            const pendentes = comandasData.reduce((acc, comanda) => {
                return acc + (comanda.pedidos?.filter((p) => p.status !== "pronto").length || 0);
            }, 0);

            setKpis({ total: mesasData.length, pendentes });
            setMesas(mesasComComandas.filter((m) => m.comanda_aberta !== null));

        } catch (error) {
            console.error("Erro ao carregar mesas + comandas:", error);
        }
    }, [activeRestaurant, Headers]);

    useEffect(() => {
        if (!localStorage.getItem("accessToken")) return;

        api.get("/printer").then(res => {
            if (res.data.length > 0) setPrinterConfig(res.data[0]);
        }).catch(() => {});

        loadMesas();
        const interval = setInterval(loadMesas, 3000);
        return () => clearInterval(interval);
    }, []);

    // ======================================================
    // CARREGAR ITENS DE MENU
    // ======================================================
    const carregarMenu = async () => {
        try {
            const resp = await api.get(`/menu/restaurant_id/${activeRestaurant.id}`, { headers: Headers });
            setItensMenu(resp.data);
            const cats = [...new Set(resp.data.map((i) => i.categoria))];
            setCategoriasMenu(cats);
            if (cats.length > 0) setCategoriaSel(cats[0]);
        } catch (err) {
            console.error("Erro ao carregar menu", err);
            setModalMessage(`Erro ao carregar itens do menu. ${err}`);
            setModalOpen(true);
        }
    };

    // ======================================================
    // ABRIR FLUXO DE DELIVERY → Criar Mesa, Criar Comanda
    // ======================================================
    const iniciarDelivery = async () => {
        const randomId = Math.random().toString(36).substring(2, 8);
        const mesaName = `Delivery-${randomId}`;

        try {
            const mesaResp = await api.post(
                "/tables",
                {
                    name: mesaName,
                    capacity: 1,
                    restaurant_id: activeRestaurant.id,
                    metadata: {
                        localizacao: "Delivery",
                        cliente_nome: clienteNome,
                        cliente_telefone: clienteTelefone,
                        endereco: clienteEndereco,
                        observacao: clienteObs,
                    },
                },
                { headers: Headers }
            );

            setMesaDelivery(mesaResp.data);
            setMesaSelecionada(mesaResp.data);

            const comandaResp = await api.post(
                "/comanda",
                { table_id: mesaResp.data.id, restaurant_id: activeRestaurant.id, opened_by: user.id },
                { headers: Headers }
            );

            setComandaSelecionada({ ...comandaResp.data, pedidos: [] });
            setComandaDelivery(comandaResp.data);
            setShowEnderecoModal(false);
            setShowModalComanda(true);
            await carregarMenu();
            setShowMenuPanel(true);

        } catch (err) {
            console.error("Erro criando Delivery", err);
            setModalMessage("Erro ao iniciar pedido delivery.");
            setModalOpen(true);
        }
    };

    // ======================================================
    // ADICIONAR ITEM
    // ======================================================
    const confirmarAddItem = async () => {
        if (!comandaSelecionada || !mesaSelecionada || !itemSelecionado) {
            setModalMessage("Selecione um item antes de adicionar o pedido.");
            setModalOpen(true);
            return;
        }

        const menuId = itemSelecionado.id ?? itemSelecionado.menu_id;

        if (!menuId) {
            setModalMessage("Erro: item selecionado sem ID de menu.");
            setModalOpen(true);
            return;
        }

        const comanda_id = comandaSelecionada.comanda_id || comandaSelecionada.id;

        try {
            await api.post(
                "/pedido",
                {
                    comanda_id,
                    restaurant_id: activeRestaurant.id,
                    mesa_id: mesaSelecionada.id,
                    itens: [{ menu_id: menuId, quantidade: qtd, notes: obs || "" }],
                },
                { headers: Headers }
            );

            setItemSelecionado(null);
            setQtd(1);
            setObs("");

            // Atualiza os pedidos da comanda exibida
            const pedidosResp = await api.get(`/pedido/comanda/${comanda_id}`, { headers: Headers });
            setComandaSelecionada(prev => ({ ...prev, pedidos: pedidosResp.data || [] }));
            setShowMenuPanel(false);
            loadMesas();

        } catch (err) {
            console.error("Erro add item", err);
            setModalMessage("Erro ao adicionar item.");
            setModalOpen(true);
        }
    };

    const visualizarComanda = (mesa) => {
        if (!mesa.comanda_aberta) return;
        setComandaSelecionada(mesa.comanda_aberta);
        setMesaSelecionada(mesa);
        setShowMenuPanel(false);
        setShowModalComanda(true);
    };

    const fecharComanda = async () => {
        try {
            const pedidos = comandaSelecionada.pedidos || [];
            const pendentes = pedidos.filter(
                (p) => p.status !== "entregue" && p.status !== "finalizado" && p.status !== "cancelado"
            );

            await Promise.allSettled(
                pendentes.map((pedido) =>
                    api.patch(`/cozinha/pedido/${pedido.id}/status`, { status: "entregue" }, { headers: Headers })
                )
            );

            await api.patch(
                `/comanda/${comandaSelecionada.comanda_id}/fechar`,
                { closed_by: user.id },
                { headers: Headers }
            );

            try {
                await api.patch(`/tables/${mesaSelecionada.id}`, { status: "encerrado" }, { headers: Headers });
            } catch (patchErr) {
                console.warn("Aviso: não foi possível atualizar status da mesa delivery:", patchErr);
            }

            setShowModalComanda(false);
            setShowMenuPanel(false);
            setModalMessage(`Delivery ${comandaSelecionada.mesa} encerrado com sucesso!`);
            setModalOpen(true);
            loadMesas();
        } catch (err) {
            console.error("Erro ao fechar comanda:", err);
            setShowModalComanda(false);
            setShowMenuPanel(false);
            setModalMessage("Erro ao fechar comanda delivery.");
            setModalOpen(true);
        }
    };

    const imprimirNoBrowser = async (comanda) => {
        const pedidos = comanda.pedidos || [];
        const total = pedidos.reduce((acc, p) => acc + p.quantidade * Number(p.Menu?.preco || 0), 0);
        const agora = new Date().toLocaleString("pt-BR");

        let pixPayload = "";
        const cnpj = activeRestaurant?.cnpj;
        if (cnpj) {
            const txid = 'RST' + String(comanda.comanda_id).replace(/[^a-zA-Z0-9]/g, '').slice(-8);
            pixPayload = gerarPayloadPix({
                chave: cnpj,
                nome: activeRestaurant.nome || 'Restaurante',
                cidade: activeRestaurant?.address?.city || 'Brasil',
                valor: total,
                txid,
            });
        }

        const pixHtml = pixPayload ? `
            <hr/>
            <p style="text-align:center;margin:4px 0">Pague com Pix</p>
            <div id="qrpix" style="display:flex;justify-content:center;margin:6px 0"></div>
            <p style="text-align:center;font-size:10px">Abra seu banco · Pix · Ler QR Code</p>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js"><\/script>
            <script>new QRCode(document.getElementById('qrpix'),{text:'${pixPayload}',width:120,height:120,correctLevel:QRCode.CorrectLevel.M});<\/script>
        ` : "";

        const linhas = pedidos.map(p => {
            const nome = p.Menu?.nome || "Item";
            const preco = Number(p.Menu?.preco || 0);
            const subtotal = preco * p.quantidade;
            return `<tr>
                <td>${p.quantidade}x ${nome}</td>
                <td style="text-align:right;white-space:nowrap;padding-left:8px">R$ ${subtotal.toFixed(2)}</td>
            </tr>`;
        }).join("");

        const html = `
            <html><head><title>Comanda Delivery</title>
            <style>
                * { box-sizing: border-box; }
                body { font-family: monospace; font-size: 12px; margin: 0; padding: 8px; }
                h2, p { text-align: center; margin: 3px 0; }
                hr { border: none; border-top: 1px dashed #000; margin: 4px 0; }
                table { width: 100%; border-collapse: collapse; }
                td { padding: 2px 0; word-break: break-word; }
                td:last-child { text-align: right; white-space: nowrap; padding-left: 8px; }
                .total { font-size: 14px; font-weight: bold; text-align: right; margin-top: 6px; }
                @media print { body { margin: 0; padding: 4px; } @page { margin: 4mm; } }
            </style></head>
            <body>
                <h2>${activeRestaurant.nome || "Restaurante"}</h2>
                <p>${agora}</p>
                <hr/>
                <p><strong>DELIVERY</strong> — #${String(comanda.comanda_id).slice(-5)}</p>
                <hr/>
                <table>${linhas}</table>
                <hr/>
                <p class="total">Total: R$ ${total.toFixed(2)}</p>
                ${pixHtml}
                <br/><br/>
            </body></html>`;

        const iframe = document.createElement("iframe");
        iframe.style.cssText = "position:fixed;top:-9999px;left:-9999px;width:0;height:0;border:none;";
        document.body.appendChild(iframe);
        iframe.contentDocument.open();
        iframe.contentDocument.write(html);
        iframe.contentDocument.close();
        setTimeout(() => {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            setTimeout(() => document.body.removeChild(iframe), 1000);
        }, 800);
    };

    const imprimirComanda = async () => {
        try {
            if (printerConfig?.type === "ip") {
                await api.post(`/imprimir/comanda`, {
                    comanda_id: comandaSelecionada.comanda_id,
                    restaurant_id: activeRestaurant.id
                });
            } else {
                await imprimirNoBrowser(comandaSelecionada);
            }
            setModalMessage("Comanda enviada para impressão!");
            setModalOpen(true);
        } catch (err) {
            console.error("Erro ao imprimir comanda:", err);
            setModalMessage(err.response?.data?.error || "Erro ao imprimir comanda.");
            setModalOpen(true);
        }
    };

    const abrirMenuPanel = async () => {
        await carregarMenu();
        setShowMenuPanel(true);
    };

    // ======================================================
    // RENDER
    // ======================================================
    return (
        <div className="delivery-container">

            {/* HEADER */}
            <div className="delivery-header">
                <div>
                    <div className="delivery-left">
                        <img src="/assets/logo-mesaclick.png" alt="MesaClick" className="delivery-logo" onClick={() => navigate("/home")} />
                        <h1 className="delivery-title">Delivery</h1>
                        {activeRestaurant && (
                            <span className="mc-rest-badge">
                                <span className="mc-rest-badge-dot" />
                                {activeRestaurant.nome}
                            </span>
                        )}
                    </div>
                    <button className="delivery-btn-novo" onClick={() => setShowEnderecoModal(true)}>
                        Novo Delivery
                    </button>
                </div>

                <div className="kpi-container-dl">
                    <div className="kpi-card-dl">
                        <span className="kpi-card-title-dl">Total Delivery</span>
                        <span className="kpi-card-value-dl">{kpis.total}</span>
                    </div>
                    <div className="kpi-card-dl">
                        <span className="kpi-card-title-dl">Pedidos pendentes</span>
                        <span className="kpi-red-dl">{kpis.pendentes}</span>
                    </div>
                </div>
            </div>

            {/* CARDS DE DELIVERY */}
            <div className="delivery-grid">
                {mesas.map((mesa) => {
                    const pendentes = mesa.comanda_aberta
                        ? mesa.comanda_aberta.pedidos.filter((p) => p.status !== "entregue").length
                        : 0;

                    return (
                        <div key={mesa.id} className={`mesa-card ${pendentes > 0 ? "mesa-alerta" : ""}`}>
                            <div className="mesa-nome">{mesa.name}</div>

                            <div className="mesa-status-container">
                                <span className={`status-badge ${mesa.comanda_aberta ? "status-ocupada" : "status-livre"}`}>
                                    {mesa.comanda_aberta ? "Ocupada" : "Disponível"}
                                </span>
                            </div>

                            {pendentes > 0 && (
                                <span className="mesa-badge-pend">{pendentes} pendente(s)</span>
                            )}

                            {mesa.metadata?.endereco && (
                                <p className="delivery-endereco">
                                    <strong>Endereço:</strong> {mesa.metadata.endereco}
                                </p>
                            )}

                            {mesa.comanda_aberta && (
                                <button className="mesa-visualizar-btn" onClick={() => visualizarComanda(mesa)}>
                                    Ver
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>


            <ModalMesaClick open={modalOpen} message={modalMessage} onClose={() => setModalOpen(false)} />

            {/* MODAL COMANDA + PAINEL DE MENU (lado a lado) */}
            {showModalComanda && (
                <div className="modal-overlay" onClick={() => { setShowModalComanda(false); setShowMenuPanel(false); }}>
                    <div className={`dl-modal-wrapper${showMenuPanel ? " dl-modal-wrapper--expanded" : ""}`} onClick={(e) => e.stopPropagation()}>

                        {/* Detalhe da comanda */}
                        <div className="modal-comanda">
                            <h2 className="modal-title">
                                {comandaSelecionada.mesa} — #{(comandaSelecionada.comanda_id || comandaSelecionada.id || "").slice(-5)}
                            </h2>

                            {/* Info do cliente */}
                            {mesaSelecionada?.metadata?.cliente_nome && (
                                <div className="dl-cliente-info">
                                    <span>👤 {mesaSelecionada.metadata.cliente_nome}</span>
                                    {mesaSelecionada.metadata.cliente_telefone && (
                                        <span>📞 {mesaSelecionada.metadata.cliente_telefone}</span>
                                    )}
                                    {mesaSelecionada.metadata.endereco && (
                                        <span>📍 {mesaSelecionada.metadata.endereco}</span>
                                    )}
                                </div>
                            )}

                            <h4 className="modal-subtitle">Itens do pedido</h4>

                            {comandaSelecionada.pedidos?.length > 0 ? (
                                <div className="modal-items-scroll">
                                    <ul className="modal-items-list">
                                        {comandaSelecionada.pedidos.map((p) => {
                                            const nomeItem = p.Menu?.nome || "Item";
                                            const preco = Number(p.Menu?.preco || 0);
                                            const subtotal = preco * p.quantidade;
                                            return (
                                                <li key={p.id} className="modal-item">
                                                    <div className="item-left">
                                                        <strong>{p.quantidade}x</strong> — {nomeItem}
                                                        <span className="item-status">({p.status})</span>
                                                    </div>
                                                    <div className="item-right">
                                                        <span className="preco-unit">R$ {preco.toFixed(2)}</span>
                                                        <span className="preco-subtotal">R$ {subtotal.toFixed(2)}</span>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : (
                                <p className="modal-empty">Nenhum item adicionado ainda.</p>
                            )}

                            <div className="modal-total">
                                <span>Total:</span>
                                <strong>
                                    R$ {(comandaSelecionada.pedidos || [])
                                        .reduce((acc, p) => acc + p.quantidade * Number(p.Menu?.preco || 0), 0)
                                        .toFixed(2)}
                                </strong>
                            </div>

                            <button className="modal-btn-pedido" onClick={abrirMenuPanel}>
                                {showMenuPanel ? "Ocultar Cardápio" : "Adicionar Pedido"}
                            </button>

                            <button className="modal-btn-print" onClick={imprimirComanda}>
                                Imprimir Comanda
                            </button>

                            <button className="modal-btn-close" onClick={() => { setShowModalComanda(false); setShowMenuPanel(false); }}>
                                Fechar Janela
                            </button>

                            <button className="modal-btn-danger" onClick={fecharComanda}>
                                Fechar Comanda
                            </button>
                        </div>

                        {/* Painel do Cardápio (aparece ao lado) */}
                        {showMenuPanel && (
                            <div className="dl-menu-panel">
                                <div className="dl-menu-panel-header">
                                    <h3>Cardápio</h3>
                                    <button className="dl-menu-panel-close" onClick={() => setShowMenuPanel(false)}>✕</button>
                                </div>

                                <div className="dl-menu-cats">
                                    {categoriasMenu.map((cat) => (
                                        <button
                                            key={cat}
                                            className={`dl-cat-btn${categoriaSel === cat ? " active" : ""}`}
                                            onClick={() => setCategoriaSel(cat)}
                                        >
                                            {cat}
                                        </button>
                                    ))}
                                </div>

                                <div className={`dl-menu-items${itemSelecionado ? " dl-menu-items--compact" : ""}`}>
                                    {itensMenu
                                        .filter((i) => i.categoria === categoriaSel)
                                        .map((item) => (
                                            <div
                                                key={item.id}
                                                className={`dl-menu-item-card${itemSelecionado?.id === item.id ? " dl-menu-item-card--selected" : ""}`}
                                                onClick={() => { setItemSelecionado(item); setQtd(1); setObs(""); }}
                                            >
                                                {item.foto ? (
                                                    <img src={`data:image/jpeg;base64,${item.foto}`} className="dl-menu-item-foto" alt={item.nome} />
                                                ) : (
                                                    <div className="dl-menu-item-foto dl-menu-item-foto--placeholder">🍽️</div>
                                                )}
                                                <div className="dl-menu-item-body">
                                                    <span className="dl-menu-item-nome">{item.nome}</span>
                                                    {item.descricao && <span className="dl-menu-item-desc">{item.descricao}</span>}
                                                    <span className="dl-menu-item-preco">R$ {Number(item.preco).toFixed(2)}</span>
                                                </div>
                                                <button
                                                    className="dl-menu-item-add"
                                                    onClick={(e) => { e.stopPropagation(); setItemSelecionado(item); setQtd(1); setObs(""); }}
                                                >
                                                    +
                                                </button>
                                            </div>
                                        ))}
                                </div>

                                {/* Seção do item selecionado — aparece na base do painel */}
                                {itemSelecionado && (
                                    <div className="dl-selected-item">
                                        <div className="dl-selected-item-top">
                                            {itemSelecionado.foto ? (
                                                <img src={`data:image/jpeg;base64,${itemSelecionado.foto}`} className="dl-selected-foto" alt={itemSelecionado.nome} />
                                            ) : (
                                                <div className="dl-selected-foto dl-selected-foto--placeholder">🍽️</div>
                                            )}
                                            <div className="dl-selected-info">
                                                <span className="dl-selected-nome">{itemSelecionado.nome}</span>
                                                {itemSelecionado.descricao && <span className="dl-selected-desc">{itemSelecionado.descricao}</span>}
                                                <span className="dl-selected-preco">R$ {Number(itemSelecionado.preco).toFixed(2)}</span>
                                            </div>
                                            <button className="dl-selected-clear" onClick={() => setItemSelecionado(null)}>✕</button>
                                        </div>

                                        <div className="dl-selected-controls">
                                            <div className="dl-selected-qtd">
                                                <button onClick={() => setQtd((q) => Math.max(1, q - 1))}>−</button>
                                                <span>{qtd}</span>
                                                <button onClick={() => setQtd((q) => q + 1)}>+</button>
                                            </div>
                                            <textarea
                                                className="dl-selected-obs"
                                                placeholder="Observação (opcional)"
                                                value={obs}
                                                onChange={(e) => setObs(e.target.value)}
                                                rows={2}
                                            />
                                            <button className="dl-selected-add-btn" onClick={confirmarAddItem}>
                                                Adicionar — R$ {(Number(itemSelecionado.preco) * qtd).toFixed(2)}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* MODAL: INFORMAÇÕES DO DELIVERY */}
            {showEnderecoModal && (
                <div className="modal-overlay" onClick={() => setShowEnderecoModal(false)}>
                    <div className="modal-endereco" onClick={(e) => e.stopPropagation()}>
                        <h2>Informações do Delivery</h2>

                        <label>Nome do Cliente</label>
                        <input type="text" value={clienteNome} onChange={(e) => setClienteNome(e.target.value)} />

                        <label>Telefone</label>
                        <input type="text" value={clienteTelefone} onChange={(e) => setClienteTelefone(e.target.value)} />

                        <label>Endereço *</label>
                        <textarea required value={clienteEndereco} onChange={(e) => setClienteEndereco(e.target.value)} />

                        <label>Observações</label>
                        <textarea value={clienteObs} onChange={(e) => setClienteObs(e.target.value)} />

                        <button className="modal-btn-pedido" onClick={() => iniciarDelivery()} disabled={!clienteEndereco}>
                            Continuar
                        </button>

                        <button className="modal-btn-close" onClick={() => setShowEnderecoModal(false)}>
                            Cancelar
                        </button>
                    </div>
                </div>
            )}

        </div>
    );
};

export default DeliveryPage;
